import React from "react";
import { isEmpty } from "lodash";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import FontIcon from "material-ui/FontIcon";
import { connect } from "../../utils";
import { CLIENT_URL } from "../../../../../restClient";
const defaultBorder = {
  type: "solid",
  size: 0,
  color: "#e61919"
};

const FlatButtonView = props => {
  const { id, layoutState } = props;
  const {
    icon,
    text,
    buttonAlign,
    containerPadding,
    href,
    buttonColors,
    fullWidth,
    labelPosition,
    typeButton,
    border,
    urlSlug
  } = layoutState.getItemJS(id).props.values;
  const isBorder = border
    ? `${border.size}px ${border.type} ${border.color}`
    : `${defaultBorder.size}px ${defaultBorder.type} ${defaultBorder.color}`;
  const childIcon = !isEmpty(icon) ? (
    <FontIcon className="material-icons"> {icon} </FontIcon>
  ) : null;
  let link = href.url;
  if (href.isCollection) {
    if (href.collection !== 0) {
      link = `${CLIENT_URL}/dashboard/collections/${href.collection}`;
    } else {
      if (urlSlug && urlSlug.value) {
        link = `${CLIENT_URL}/${urlSlug.value}`;
      }
    }
  }

  const childButton =
    typeButton === "raised" ? (
      <RaisedButton
        label={text}
        href={link}
        target={href.target}
        fullWidth={fullWidth}
        labelPosition={labelPosition}
        icon={childIcon}
        labelColor={buttonColors.color}
        backgroundColor={buttonColors.backgroundColor}
        labelStyle={{ textTransform: "none", border: isBorder }}
        style={{ height: "auto", lineHeight: "200%" }}
      />
    ) : (
      <FlatButton
        label={text}
        href={link}
        target={href.target}
        fullWidth={fullWidth}
        labelPosition={labelPosition}
        icon={childIcon}
        hoverColor={buttonColors.hoverColor}
        backgroundColor={buttonColors.backgroundColor}
        rippleColor={buttonColors.rippleColor}
        style={{
          color: buttonColors.color,
          height: "auto",
          lineHeight: "200%",
          border: isBorder
        }}
        labelStyle={{ textTransform: "none" }}
      />
    );
  return (
    <div
      style={{
        boxSizing: "border-box",
        position: "relative",
        height: "auto",
        display: "flex",
        width: "100%",
        justifyContent: buttonAlign,
        flex: 1,
        padding: containerPadding
      }}
    >
      {childButton}
    </div>
  );
};

export default connect("layoutState")(FlatButtonView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/FlatButtonView.js